import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import FeedbackCard from "./FeedbackCard";
import { trackEvent } from "../../utils/analytics";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../Testimonial/Testimonial.css";

const testimonials = [
  {
    quote:
      "Spiderlegs Productionsin äänentoistokalusto teki hääjuhlastamme täydellisen. Oli valtava helpotus, kun ei tarvinnut stressata tekniikasta – kaikki toimi moitteettomasti.",
    author: "Mira",
    position: "Hääasiakas",
    type: "Häät",
  },
  {
    quote:
      "Yritystapahtuman järjestäminen oli helppoa, kun saimme kaiken tarvittavan tekniikan yhdestä paikasta. Vuokrausprosessi oli selkeä ja kuljetuspalvelu iso plussa.",
    author: "Marcus F.",
    position: "Yritystapahtuma",
    type: "Yritykset",
  },
  {
    quote:
      "Teemabileiden karaoke onnistui täydellisesti – bilekaiutin ja langattomat mikrofonit olivat juuri sitä mitä tarvittiin. Nouto ja palautus sujuivat vaivattomasti.",
    author: "Sanna T.",
    position: "Juhlien järjestäjä",
    type: "Juhlat",
  },
  {
    quote:
      "Valot ja savukone loivat juhliin aivan uuden tunnelman. Kaikki laitteet olivat siistejä, helppokäyttöisiä ja selkeästi ohjeistettu.",
    author: "Janne L.",
    position: "Yksityistilaisuus",
    type: "Valotekniikka",
  },
  {
    quote:
      "Pikkujoulujen tunnelma oli huipussaan Spiderlegsin äänentoiston ja valotekniikan ansiosta. Erinomainen valinta yritystapahtumiin.",
    author: "Heidi M.",
    position: "HR-päällikkö",
    type: "Pikkujoulut",
  },
  {
    quote:
      "Kärryn vuokraus sujui todella mutkattomasti. Siisti, tilava ja hyvin huollettu kuomukärry – juuri sitä mitä tarvitsin muuttoon.",
    author: "Timo K.",
    position: "Vuokrausasiakas",
    type: "Peräkärry",
  },
];

const Testimonial = () => {
  const hasTrackedView = useRef(false);

  useEffect(() => {
    if (!hasTrackedView.current) {
      trackEvent("asiakaspalaute_nakyvissa", {
        sijainti: "etusivu",
        maara: testimonials.length,
      });

      hasTrackedView.current = true;
    }
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 650,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
    arrows: true,
    adaptiveHeight: false,
    pauseOnHover: true,
    afterChange: (index) => {
      trackEvent("asiakaspalaute_vaihtui", {
        index,
        kirjoittaja: testimonials[index]?.author,
      });
    },
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <section
      className="
        relative overflow-hidden py-20
        bg-gradient-to-br from-white via-[#F3FFFC] to-[#E9FBF7]
        dark:from-[#050505] dark:via-[#08080A] dark:to-[#0D0D12]
      "
      aria-labelledby="testimonial-heading"
    >
      <div className="mx-auto max-w-7xl px-4">
        <div
          className="
            rounded-[2rem] border border-[#DDE7E5] bg-white p-6 shadow-xl
            dark:border-darkborder dark:bg-[#111114]
            md:p-8
          "
        >
          {/* Otsikko */}
          <div className="mb-10 max-w-4xl">
            <span
              className="
                mb-4 inline-flex rounded-full border border-primary/40 bg-primary/10
                px-4 py-2 font-customFont1 text-sm font-extrabold uppercase
                tracking-[0.14em] !text-[#111827]
                dark:!text-white
              "
            >
              Asiakkaiden kokemuksia
            </span>

            <h2
              id="testimonial-heading"
              className="
                font-customFont2 text-left text-3xl sm:text-3xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-snug
                text-text
                dark:text-darktext
              "
            >
              Asiakaspalautteet
            </h2>

            <p
              className="
                mt-5 max-w-3xl font-customFont1 text-left text-lg font-normal
                leading-relaxed !text-[#374151]
                dark:!text-[#D1D5DB]
                xl:text-xl
              "
            >
              Lue, miksi asiakkaat ovat valinneet Spiderlegs Productionsin
              äänentoiston, valotekniikan, kuljetuksen ja tapahtumatekniikan
              vuokraukseen.
            </p>
          </div>

          {/* Slider */}
          <div className="testimonial-slider">
            <Slider {...settings}>
              {testimonials.map((testimonial) => (
                <div key={`${testimonial.author}-${testimonial.type}`} className="px-3 pb-12">
                  <FeedbackCard {...testimonial} />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;